import React from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function LegalModal({
  isOpen,
  onClose
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-155">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-156" />

      <div className="relative w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all flex flex-col max-h-[90vh]" data-id="element-157">
        <div className="flex items-center justify-between border-b border-gray-200 pb-4" data-id="element-158">
          <h3 className="text-2xl font-bold text-gray-900" data-id="element-159">
            Aviso Legal y Condiciones
          </h3>
          <button onClick={onClose} className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors" aria-label="Cerrar modal" data-id="element-160">
            <XIcon className="h-6 w-6" data-id="element-161" />
          </button>
        </div>

        <div className="mt-4 flex-1 overflow-y-auto pr-2 text-gray-600 space-y-4" data-id="element-162">
          <p data-id="element-163">
            <strong data-id="element-164">1. Datos identificativos</strong>
            <br data-id="element-165" />
            En cumplimiento con el deber de información recogido en artículo 10
            de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
            Información y del Comercio Electrónico, a continuación se reflejan
            los siguientes datos: la empresa titular de dominio web es Talleres
            Trivi (en adelante Trivi), con domicilio a estos efectos en Madrid,
            España. Correo electrónico de contacto del sitio web.
          </p>

          <p data-id="element-166">
            <strong data-id="element-167">2. Usuarios</strong>
            <br data-id="element-168" />
            El acceso y/o uso de este portal de Trivi atribuye la condición de
            USUARIO, que acepta, desde dicho acceso y/o uso, las Condiciones
            Generales de Uso aquí reflejadas.
          </p>

          <p data-id="element-169">
            <strong data-id="element-170">3. Uso del portal</strong>
            <br data-id="element-171" />
            El sitio web proporciona el acceso a multitud de informaciones,
            servicios, programas o datos (en adelante, "los contenidos") en
            Internet pertenecientes a Trivi o a sus licenciantes a los que el
            USUARIO pueda tener acceso. El USUARIO asume la responsabilidad del
            uso del portal.
          </p>

          <p data-id="element-172">
            <strong data-id="element-173">4. Protección de datos</strong>
            <br data-id="element-174" />
            Trivi cumple con las directrices de la normativa vigente en materia
            de protección de datos personales, el Reglamento (UE) 2016/679 de 27
            de abril de 2016 (RGPD), y vela por garantizar un correcto uso y
            tratamiento de los datos personales del usuario.
          </p>

          <p data-id="element-175">
            <strong data-id="element-176">5. Propiedad intelectual e industrial</strong>
            <br data-id="element-177" />
            Trivi por sí o como cesionaria, es titular de todos los derechos de
            propiedad intelectual e industrial de su página web, así como de los
            elementos contenidos en la misma (a título enunciativo, imágenes,
            sonido, audio, vídeo, software o textos; marcas o logotipos,
            combinaciones de colores, estructura y diseño, etc.).
          </p>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end" data-id="element-178">
          <button type="button" className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 transition-colors" onClick={onClose} data-id="element-179">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}